import React, { createContext, useEffect, useReducer, useMemo, useRef } from "react";
import axios from "axios";
import { MatxLoading } from "../components";
import APIKit from "../../config/APIKit";
import {loggin, addPermission} from '../store/compatibility';
import {useDispatch,useSelector} from 'react-redux';
import socketService from '../services/socketService';
// import { useNavigate} from 'react-router-dom'
const initialState = {
  isAuthenticated: false,
  isInitialised: false,
  user: null,
};

const isValidToken = async (accessToken) => {
  if (!accessToken) {
    return false;
  }
  let valid = {
    status: false,
  };
  await APIKit.get("/me").then((res) => {
    if (res) {
      valid = {
        status: true,
        ...res.data,
        user: res,
      };
    }
  });
  return valid;
};

const setSession = (accessToken) => {
  
  if (accessToken) {
    localStorage.setItem("accessToken", accessToken);
    axios.defaults.headers.common.Authorization = `Bearer ${accessToken}`;
  } else {
    localStorage.removeItem("accessToken");
    delete axios.defaults.headers.common.Authorization;
  }
};

const reducer = (state, action) => {
  switch (action.type) {
    case "INIT": {
      const { isAuthenticated, user } = action.payload;

      return {
        ...state,
        isAuthenticated,
        isInitialised: true,
        user,
      };
    }
    case "LOGIN": {
      const { user } = action.payload;

      return {
        ...state,
        isAuthenticated: true,
        user,
      };
    }
    case "LOGOUT": {
      return {
        ...state,
        isAuthenticated: false,
        user: null,
      };
    }
    case "REGISTER": {
      const { user } = action.payload;

      return {
        ...state,
        isAuthenticated: true,
        user,
      };
    }
    default: {
      return { ...state };
    }
  }
};

const AuthContext = createContext({
  ...initialState,
  method: "JWT",
  login: () => Promise.resolve(),
  logout: () => {},
  register: () => Promise.resolve(),
});

export const AuthProvider = ({ children }) => {
  const [state, dispatch] = useReducer(reducer, initialState);
  const reduxDisPatch = useDispatch();
  // Support both old and new store structure for backward compatibility
  // Select only the specific fields we need to avoid creating new objects on every render
  const authState = useSelector(state => state.auth);
  const loggedState = useSelector(state => state.logged);
  
  // Memoize userDatas to prevent infinite loops
  const userDatas = useMemo(() => {
    // New store structure uses state.auth
    if (authState) {
      return {
        role: authState.role,
        isAdmin: authState.isAdmin,
        isLogged: authState.isLogged,
        token: authState.token,
      };
    }
    // Fallback to old structure for backward compatibility
    return loggedState || {};
  }, [authState, loggedState]);
  const login = async (email, password) => {
    const response = await APIKit.post("/login", {
      username:email,
      password,
    });
    
    const { accessToken, new_password } = response.data;
    
    if(!new_password){
      setSession(accessToken);
      dispatch({
        type: "LOGIN",
        payload: response.data,
      });
      reduxDisPatch(loggin(response.data))

    }
    return response.data
  };

  const register = async (email, username, password) => {
    const response = await axios.post("/api/auth/register", {
      email,
      username,
      password,
    });

    const { accessToken, user } = response.data;

    setSession(accessToken);

    dispatch({
      type: "REGISTER",
      payload: {
        user,
      },
    });
  };

  const logout = () => {
    setSession(null);
    socketService.disconnect();
    dispatch({ type: "LOGOUT" });
  };
  // const navigate = useNavigate();
  useEffect(() => {
    (async () => {
      try {
        const accessToken = window.localStorage.getItem("accessToken");
        if (accessToken) {
          isValidToken(accessToken).then((res) => {
            
            if (res) {
              const { user } = res;
              const userData = {
                token : accessToken,
                ...res
              }
              reduxDisPatch(loggin(userData))
              setSession(accessToken);

              dispatch({
                type: "INIT",
                payload: {
                  isAuthenticated: true,
                  user,
                },
              });
            } else {
              dispatch({
                type: "INIT",
                payload: {
                  isAuthenticated: false,
                  user: null,
                },
              });
            }
          }).catch(err=>{
            localStorage.clear();
            dispatch({
              type: "INIT",
              payload: {
                isAuthenticated: false,
                user: null,
              },
            });
            // navigate('/session/signin');
          })
          
        } else {
          dispatch({
            type: "INIT",
            payload: {
              isAuthenticated: false,
              user: null,
            },
          });
        }
      } catch (err) {
        dispatch({
          type: "INIT",
          payload: {
            isAuthenticated: false,
            user: null,
          },
        });
      }
    })();
  }, [reduxDisPatch]);
  useEffect(()=>{
    // Only call API if role exists and hasn't been called before
    const userRole = authState?.role || loggedState?.role;
    if (userRole) {
      APIKit.get(`/getPermission`).then(res=>{
        if(res.status){
          reduxDisPatch(addPermission(res.data))
        }
      }).catch(err => {
        console.error('Error fetching permissions:', err);
      });
    }
  },[authState?.role, loggedState?.role, reduxDisPatch])

  if (!state.isInitialised) {
    return <MatxLoading />;
  }

  return (
    <AuthContext.Provider
      value={{
        ...state,
        method: "JWT",
        login,
        logout,
        register,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export default AuthContext;
